export default "/ressources/logged/img/icon/svg/schedule-email-fill.svg";